module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<span class=\"text-nowrap\">")
    ; __append(escapeFn( locals.startDate ))
    ; __append("</span><span class=\"daterange-separator\"></span><span class=\"text-nowrap\">")
    ; __append(escapeFn( locals.endDate ))
    ; __append("</span> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/list/item/headings/date_range/template.ejs
// module id = 788
// module chunks = 1